
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.875 4.5h12M4.375 4.5h9v9a1 1 0 01-1 1h-7a1 1 0 01-1-1v-9zM6.375 4.5V4a2.5 2.5 0 115 0v.5","stroke":"#339299","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    